import React from 'react';
import { Mail, Instagram, Plane } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-[#2c2825] pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16 pb-16 border-b border-[#faf8f5]/10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="font-display text-2xl text-[#c9b896] mb-1" style={{ fontWeight: 500 }}>
                {companyInfo.name}
              </h3>
              <p className="text-sm text-[#faf8f5]/60">
                {companyInfo.nameArabic}
              </p>
            </div>
            <p className="text-sm text-[#faf8f5]/80 leading-relaxed mb-6">
              Elite Cabin Crew Recruitment with Royal Elegance, Luxury, Discretion and Excellence.
            </p>
            <div className="flex items-center gap-4">
              <Plane size={24} className="text-[#c9b896]/50" strokeWidth={1} />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-6">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-4">
              {['About', 'Why Us', 'Candidates', 'Careers'].map((link) => (
                <a
                  key={link}
                  href={`#${link.toLowerCase().replace(' ', '-')}`}
                  className="text-sm text-[#faf8f5]/70 hover:text-[#c9b896] transition-colors duration-300"
                >
                  {link}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs tracking-[0.3em] uppercase text-[#c9b896] mb-6">
              Get In Touch
            </h4>
            <div className="space-y-4">
              <a
                href={`mailto:${companyInfo.email}`}
                className="flex items-center gap-3 text-sm text-[#faf8f5]/70 hover:text-[#c9b896] transition-colors duration-300 group"
              >
                <Mail size={18} className="text-[#c9b896]" strokeWidth={1.5} />
                <span>{companyInfo.email}</span>
              </a>
              <a
                href={companyInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-[#faf8f5]/70 hover:text-[#c9b896] transition-colors duration-300 group"
              >
                <Instagram size={18} className="text-[#c9b896]" strokeWidth={1.5} />
                <span>@{companyInfo.instagram}</span>
              </a>
            </div>

            {/* CTA */}
            <div className="mt-8">
              <a
                href={`mailto:${companyInfo.email}?subject=Inquiry - SaraPrivéAviation`}
                className="inline-flex items-center gap-2 px-6 py-3 border border-[#c9b896] text-[#c9b896] text-xs tracking-widest uppercase hover:bg-[#c9b896] hover:text-[#2c2825] transition-all duration-300"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#faf8f5]/40">
            © {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-[#faf8f5]/40">
            Europe & Middle East
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
